import { Exclude, Type } from 'class-transformer';
import { ARPaymentTransferAccountRawDto } from './ar-payment-transfer-account-raw-dto';

export class ARPaymentTransferAccountDetailsRawDto {
    debitAccountDescription: string;
    @Type(() => ARPaymentTransferAccountRawDto)
    creditAccountInfo: ARPaymentTransferAccountRawDto;
    transferAmount: number;
    // Transient variable
    @Exclude()
    communityName?: string;
    @Exclude()
    accountName?: string;
}
